(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
if (!window.ppCartPageRewards) {
  window.ppCartPageRewards = true;
  let rewardRoot;
  const preserveRewardRoot = () => {
    const page = document.querySelector('.pp-cart-page');
    if (!page) return;
    const current = page.querySelector('[id="mcb__rewards-on-cart-widget__root"]');
    if (!current) return;
    if (!rewardRoot) rewardRoot = current;
    else if (current !== rewardRoot) current.replaceWith(rewardRoot);
  };
  preserveRewardRoot();
  const page = document.querySelector('.pp-cart-page');
  if (page) new MutationObserver(preserveRewardRoot).observe(page, {childList:true, subtree:true});
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-erhverv"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('.ppe a[href="#tilbud"]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'start'
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-help-center"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-help-center')) {
  customElements.define('pp-help-center', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.input = this.querySelector('[data-search]');
      this.groups = [...this.querySelectorAll('[data-group]')];
      this.questions = [...this.querySelectorAll('[data-question]')];
      this.links = [...this.querySelectorAll('[data-category]')];
      this.category = '*';
      this.index = new Map(this.questions.map(item => [item, this.normalize(item.querySelector('summary').textContent + ' ' + item.querySelector('.pp-help-richtext').textContent + ' ' + item.dataset.keywords)]));
      this.querySelector('[data-search-wrap]').hidden = false;
      this.input.addEventListener('input', () => { this.category = '*'; this.filter(); }, options);
      this.input.addEventListener('keydown', event => { if (event.key === 'Escape') { this.reset(); } }, options);
      this.querySelector('[data-clear]').addEventListener('click', () => this.reset(), options);
      this.querySelector('[data-reset]').addEventListener('click', () => this.reset(), options);
      this.links.forEach(link => link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); this.category = link.dataset.category; this.input.value = ''; this.filter();
        this.setHash(link.hash);
      }, options));
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-answer-link]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); this.setHash(link.hash); this.openHash(true);
      }, options);
      window.addEventListener('hashchange', () => this.openHash(true), options);
      document.addEventListener('shopify:block:select', event => {
        const topic = event.target.closest('[data-group]');
        if (topic && this.contains(topic)) { this.category = topic.dataset.group; this.input.value = ''; this.filter(); topic.scrollIntoView({block:'center'}); }
        const question = event.target.closest('[data-question]');
        if (question && this.contains(question)) { this.category = '*'; this.input.value = ''; this.filter(); question.open = true; question.scrollIntoView({block:'center'}); }
      }, options);
      this.filter(false);
      this.openHash(false);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    normalize(text) { return text.toLocaleLowerCase('da').replace(/æ/g,'ae').replace(/ø/g,'o').replace(/å/g,'a').normalize('NFD').replace(/[\u0300-\u036f]/g,''); }
    setHash(hash) { try { history.pushState(null, '', hash); } catch (_) { /* Search remains available when history is restricted. */ } }
    reset() { this.input.value = ''; this.category = '*'; this.filter(); this.input.focus(); }
    filter(announce = true) {
      const terms = this.normalize(this.input.value.trim()).split(/\s+/).filter(Boolean);
      let count = 0;
      this.groups.forEach(group => {
        let visible = 0;
        group.querySelectorAll('[data-question]').forEach(item => {
          const match = (this.category === '*' || group.dataset.group === this.category) && terms.every(term => this.index.get(item).includes(term));
          item.hidden = !match;
          if (match) { visible++; count++; }
        });
        group.hidden = !visible;
      });
      this.links.forEach(link => { if(link.dataset.category === this.category) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); });
      this.querySelector('[data-clear]').hidden = !this.input.value;
      this.querySelector('[data-empty]').hidden = count !== 0;
      this.querySelector('[data-status]').textContent = announce ? this.dataset.countTemplate.replace('[count]', count) : '';
    }
    openHash(moveFocus) {
      let hash; try { hash = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      const target = [...this.groups, ...this.questions].find(item => item.id === hash);
      if (!target) {
        if (hash === this.querySelector('.pp-help-answers').id || !hash) { this.category = '*'; this.input.value = ''; this.filter(false); }
        return;
      }
      this.input.value = '';
      this.category = target.dataset.group || target.closest('[data-group]').dataset.group;
      this.filter(false);
      if (target.matches('[data-question]')) target.open = true;
      if (moveFocus) { target.scrollIntoView({block:'start'}); target.querySelector('summary')?.focus({preventScroll:true}); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-kundeklub"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialise(root) {
    if (root.dataset.ppReady) return;
    root.dataset.ppReady = 'true';
    function cleanClubUrl(url) {
      ['_s', '_y', 'analytics_trace_id'].forEach(key => url.searchParams.delete(key));
      return url;
    }
    const cleanUrl = cleanClubUrl(new URL(location.href));
    if (cleanUrl.href !== location.href) history.replaceState(history.state, '', cleanUrl);
    window.addEventListener('pageshow', () => {
      const url = cleanClubUrl(new URL(location.href));
      if (url.href !== location.href) history.replaceState(history.state, '', url);
    });
    const requestedOrder = new URL(location.href).searchParams.get('ordre');
    root.querySelectorAll('a[href*="/customer_authentication/login"],a[href*="/account/login"]').forEach(link => {
      const target = new URL(link.href, location.origin);
      if (requestedOrder || ['#ordrer', '#profil', '#abonnementer'].includes(location.hash)) {
        target.searchParams.set('return_to', location.pathname + location.search + location.hash);
        link.href = target.href;
      }
    });
    const nav = root.querySelector('[data-pp-tabs]');
    const tabs = [...root.querySelectorAll('[data-pp-tab]')];
    const panels = [...root.querySelectorAll('[data-pp-panel]')];
    const slugs = { club: 'fordele', orders: 'ordrer', profile: 'profil', subscriptions: 'abonnementer' };
    function tabFromHash() {
      const hash = location.hash.slice(1);
      return Object.keys(slugs).find(key => slugs[key] === hash || 'club-' + key === hash) || 'club';
    }
    function activate(name, update = false, focus = false) {
      if (!tabs.some(tab => tab.dataset.ppTab === name)) name = 'club';
      for (const tab of tabs) {
        const selected = tab.dataset.ppTab === name;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', slugs[tab.dataset.ppTab]);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      }
      for (const panel of panels) {
        panel.setAttribute('role', 'tabpanel');
        panel.tabIndex = 0;
        panel.hidden = panel.dataset.ppPanel !== name;
      }
      if (update) {
        const url = cleanClubUrl(new URL(location.href));
        url.hash = slugs[name];
        history.replaceState(null, '', url);
      }
    }
    if (nav) {
      nav.setAttribute('role', 'tablist');
      activate(requestedOrder ? 'orders' : tabFromHash());
      if (requestedOrder && /^\d+$/.test(requestedOrder)) {
        const orderCard = [...root.querySelectorAll('[data-pp-order-id]')].find(card => card.dataset.ppOrderId === requestedOrder);
        if (orderCard) {
          orderCard.open = true;
          const details = orderCard.querySelector('.pp-club-order-details');
          if (details) details.open = true;
          requestAnimationFrame(() => orderCard.scrollIntoView({ block: 'center', behavior: 'auto' }));
        }
      }
      nav.addEventListener('click', event => {
        const tab = event.target.closest('[data-pp-tab]');
        if (!tab) return;
        event.preventDefault();
        activate(tab.dataset.ppTab, true);
      });
      nav.addEventListener('keydown', event => {
        const index = tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(tabs[next].dataset.ppTab, true, true);
      });
      window.addEventListener('hashchange', () => {
        if (root.isConnected) activate(tabFromHash());
      });
      root.querySelectorAll('[data-pp-tab-link]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        activate(link.dataset.ppTabLink, true, true);
        nav.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
    }
    root.querySelectorAll('[data-club-benefits]').forEach(button => button.addEventListener('click', () => {
      const target = document.getElementById(button.dataset.clubBenefits);
      if (!target) return;
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }));
    const invite = root.querySelector('[data-pp-invite]');
    if (invite) loadInvite(invite);
  }
  async function loadInvite(box) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const endpoint = new URL(box.dataset.endpoint, location.origin);
      if (endpoint.origin !== location.origin || !endpoint.pathname.startsWith('/apps/')) return;
      const response = await fetch(endpoint, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
      if (!response.ok) return;
      const data = await response.json();
      if (!data.link || data.shareable === false || data.is_program_enabled === false) return;
      const link = new URL(data.link);
      if (link.protocol !== 'https:' || link.origin !== location.origin) return;
      const input = box.querySelector('[data-pp-invite-input]');
      const status = box.querySelector('[data-pp-copy-status]');
      input.value = link.href;
      box.querySelector('[data-pp-invite-content]').hidden = false;
      box.querySelector('[data-pp-invite-fallback]').hidden = true;
      box.querySelector('[data-pp-copy]').addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(input.value); status.textContent = status.dataset.success; }
        catch (_) { input.focus(); input.select(); status.textContent = status.dataset.error; }
      });
      const share = box.querySelector('[data-pp-share]');
      if (navigator.share) {
        share.hidden = false;
        share.addEventListener('click', async () => { try { await navigator.share({ url: input.value }); } catch (_) {} });
      }
    } catch (_) {
    } finally { clearTimeout(timeout); }
  }
  function start() { document.querySelectorAll('[data-pp-club]').forEach(initialise); }
  start();
  document.addEventListener('shopify:section:load', start);
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-lykkekasser"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a.pp-lucky__button[href="#lykkekasser"]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'start'
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-sonderthon"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(!root||root.dataset.ready)return;root.dataset.ready='true';const reduced=matchMedia('(prefers-reduced-motion: reduce)');const hero=root.querySelector('.sp-hero'),progress=root.querySelector('.sp-progress');const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('sp-visible');observer.unobserve(entry.target)}}),{threshold:.08});root.querySelectorAll('[data-enter]').forEach(el=>observer.observe(el));root.classList.add('sp-ready');let queued=false;function paint(){queued=false;const rect=hero.getBoundingClientRect();const range=Math.max(1,hero.offsetHeight-innerHeight);const v=reduced.matches?0:Math.min(1,Math.max(0,-rect.top/range));root.style.setProperty('--scene',v.toFixed(4));const ease=(a,b)=>{const t=Math.min(1,Math.max(0,(v-a)/(b-a)));return t*t*(3-2*t)};root.style.setProperty('--present',ease(0,.28));root.style.setProperty('--lift',ease(.28,.72));root.style.setProperty('--card',ease(.36,.56));root.style.setProperty('--intro-out',ease(.3,.48));root.style.setProperty('--reveal-in',ease(.68,.86));progress.style.transform='scaleX('+Math.min(1,scrollY/Math.max(1,document.documentElement.scrollHeight-innerHeight))+')'}function request(){if(!queued){queued=true;requestAnimationFrame(paint)}}addEventListener('scroll',request,{passive:true});addEventListener('resize',request);paint();root.cleanup=()=>{observer.disconnect();removeEventListener('scroll',request);removeEventListener('resize',request)}}document.querySelectorAll('[data-pitch]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-pitch]')));document.addEventListener('shopify:section:unload',e=>e.target.querySelector('[data-pitch]')?.cleanup?.())})();

  } catch(e) { console.error(e); }
})();
})();
